module.exports = __webpack_public_path__ + "img/people_ck.0862f4b9.png";